var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-menu"},[_c('a',{on:{"click":_vm.showMenu}},[_c('span',{staticClass:"bars"}),_vm._v(" Menu ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }